import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/joy";
import PlacesTemplatesRoutes from "./PlacesTemplatesRoutes";

const PlacesTemplates = (props) => {
	const { t } = useTranslation();

	return (
		<>
			<PlacesTemplatesRoutes />
		</>
	);
};

export default PlacesTemplates;
